<template>
  <div id="winter">
    <div class="top">
    </div>
    <div class="bottom">
      <img :src="'./img/rabbit.png'">
    </div>
  </div>
</template>
<script>
export default {
}
</script>
